import React from 'react'


export default class Footer extends React.Component {
  render() {
    return (
      <div id="footer">
          A <a href="http://staystatic.github.io">Stay Static</a> Sample Site
      </div>
      )
  }
}


/*
 try/use short form - why? why not?
export default ()=> {
      <div id="footer">
          A <a href="http://staystatic.github.io">Stay Static</a> Sample Site
      </div>
}
*/



/** WEBPACK FOOTER **
 ** ../components/Footer.js
 **/